import { useEffect } from 'react'
import { getMeditationPractices } from '../../../common/api/Practices'
import {
  ROUTE_ACTIVITIES_ALL,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_CHAT_GENERAL
} from '../../../common/helpers/Paths'
import {
  saveUserEvent,
  EVENT_CATEGORY_MEDITATION,
  EVENT_ACTION_PAGEVIEW,
  EVENT_VALUE_ALL
} from '../../../common/api/UserEvents'
import { KEY_PRACTICE_MEDITATIONS } from 'components/common/api'
import PracticesWithCategory from '../../PracticesWithCategory'

export default function MeditationList({
  setReturnPath,
  setHeaderTitle,
  cache
}) {
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Update Header and return path
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_ALL)

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_MEDITATION,
      EVENT_ACTION_PAGEVIEW,
      EVENT_VALUE_ALL
    )
  }, [setHeaderTitle, setReturnPath])

  return (
    <PracticesWithCategory
      cache={cache}
      practiceKey={KEY_PRACTICE_MEDITATIONS}
      baseUrl={ROUTE_ACTIVITIES_MEDITATION_ALL}
      cacheKey='ROUTE_ACTIVITIES_MEDITATION_ALL'
      handlePracticeFetch={getMeditationPractices}
      chatURI={`${ROUTE_CHAT_GENERAL}/create?returnPath=${ROUTE_ACTIVITIES_MEDITATION_ALL}`}
    />
  )
}
